<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>字典列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="字典类型">
<!--        <el-input size="small" v-model="formInline.v" clearable placeholder="输入字典值" @keyup.enter.native="search"></el-input>-->

        <el-input size="small" v-model="formInline.typeDictName" clearable placeholder="输入字典类型" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column sortable prop="v" label="字典值" width="300">
      </el-table-column>
      <el-table-column sortable prop="dictTypeName" label="字典类型" width="300">
      </el-table-column>
      <el-table-column sortable prop="createDate" label="添加时间" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.createDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column label="相关图片">
        <template slot-scope="scope">
            <el-image
                style="width: 80px; height: 50px"
                :src=scope.row.imageOss
                :preview-src-list=[scope.row.imageOss]>
                <div slot="error" class="image-slot">
                  <!-- <i class="el-icon-picture-outline"></i> -->
                  <i>———————</i>
                </div>
            </el-image>
          </template>
      </el-table-column>
      <el-table-column  prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status==0?'danger':'success'">{{activeText[scope.row.status]}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="字典名称" prop="k">
          <el-input size="small" v-model.trim="editForm.k" auto-complete="off" placeholder="请输入字典名称"></el-input>
        </el-form-item>
        <el-form-item label="字典值" prop="v">
          <el-input size="small" v-model.trim="editForm.v" auto-complete="off" placeholder="请输入字典值"></el-input>
        </el-form-item>
        <el-form-item label="字典类型" prop="dictTypeId">
          <el-select v-model="editForm.dictTypeId" clearable
              filterable placeholder="请选择字典类型" :disabled="typeDisabled" @change="typeChange">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.cnName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="uploadLabel" prop="imageOss"  v-if="uploadShow" class="logoForm">
          <el-upload
                  v-loading="uploading"
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :http-request="uploadArrBinary"
                  >
                  <img v-if="editForm.imageOss" :src="editForm.imageOss" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div slot="tip" class="img_size_tip">避免影响小程序内显示效果，请上传：70px/70px大小或等比例图片</div>
               </el-upload>
        </el-form-item>

        <el-form-item label="启用状态" prop="status">
          <el-switch
            v-model="editForm.status"
            :active-value= 1
            :inactive-value= 0
            active-text="启用"
            inactive-text="禁用">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDictListByPage,addDictList ,editDictList,delDictList,gatherOptions} from '@/api/system'
import {upimg} from '@/api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      uploadLabel:'厂家LOGO',
      typeDisabled:false,
      activeText:['禁用','启用'],
      options: [],
      uploadUrl:'http://192.168.0.126:8080/image/uploadImage',
      uploadheaders:{
        Authorization: localStorage.getItem('logintoken')
      },
      uploadShow:false,
      uploading:false,
      editForm: {
        dictTypeId:'',
        k:'',
        v:'',
        status:1,
        imageNo:'',
        imageOss:''
      },
      // rules表单验证
      rules: {
        k: [
          { required: true, message: '请输入字典名称', trigger: 'blur' }
        ],
        v: [{ required: true, message: '请输入字典值', trigger: 'blur' }],
        dictTypeId:[{ required: true, message: '请选择类型', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getDictType()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    beforeAvatarUpload(file) {
        // console.log(file,'图片文件before');
        const isJPG = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('只能上传jpg或png格式!');
        }
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
        // return isLt2M;
      },
    handleAvatarSuccess(res, file) {
        console.log(res,file,'uploadsuccess');
        // this.editForm.imageNo = URL.createObjectURL(file.raw);
        // this.editForm.imageNo = res.body.imageNo
      },
      uploadArrBinary(filePath){
        this.uploading = false
      let formData = new FormData()
        formData.append('file',filePath.file)
      // console.log('文件：',formData.get('file'));
      upimg(formData).then(res=>{
        if(res.rsp_code==200){
          this.uploading = false
          this.editForm.imageOss = res.body.ossUrl
          this.editForm.imageNo = res.body.imageNo
        }else{
          this.uploading = false
          this.$message.error('上传失败!');
        }

      })
    },
    // 获取字典类型集合
    getDictType(){
      gatherOptions()
        .then(res => {
          this.options = res.body
        })
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，
       */
       getDictListByPage(parameter).then(res => {
          this.loading = false
          if (res.rsp_code != 200) {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })
          } else {
            this.listData = res.body.records
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.body.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page=1
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.uploadShow = false
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        if(row.dictTypeId==10 || row.dictTypeId==11){
          this.uploadShow = true
        }
        this.title = '修改'
        this.editForm =row
        this.typeDisabled = true
      } else {
        this.title = '添加'
        this.typeDisabled = false
        this.editForm.dictTypeId = ''
        this.editForm.k = ''
        this.editForm.v = ''
        this.editForm.status = 1
        this.editForm.imageOss = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
            let subType = this.title == '修改'?editDictList:addDictList
            subType(this.editForm).then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.rsp_code==200) {
                    this.getdata(this.formInline)
                    this.$message({
                    type: 'success',
                    message: '保存成功！'
                    })
                } else {
                    this.$message({
                    type: 'info',
                    message: res.rsp_msg
                    })
                }
                })
                .catch(err => {
                    this.editFormVisible = false
                    this.loading = false
                    this.$message.error('保存失败，请稍后再试！')
                    })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            delDictList({id:row.id})
            .then(res => {
              if (res.rsp_code==200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      // this.getdata(this.formInline)
    },
    typeChange(id){
      let obj = {}
      obj = this.options.find((item)=>{
          return item.id === id; // 筛选出匹配数据
      });
      this.uploadLabel = obj.cnName + '图片' //upload动态label
      // if(id==10||id==11){
      if(id==11){
        this.uploadShow = true
      }
      else{
        this.uploadShow = false
        this.editForm.imageOss = ''
      }
    }
  }
}
</script>

<style scoped>

.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>
<style>
.logoForm .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .logoForm .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .logoForm .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .logoForm .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/system/dicList.vue